import {
    getCsrfTokenKey,
    getCsrfTokenKeyParamName,
    getCsrfTokenValue,
    getCsrfTokenValueParamName
} from '../../utilities/csrf_token_provider';
class ItemDropdown {
    /**
     * @param $dropdown
     * @constructor
     */
    constructor($dropdown) {
        'use strict';
        this.$dropdown = $dropdown;
        this.init();
    }

    init() {
        'use strict';
        this._bindChangeHandler();
    }

    _bindChangeHandler() {
        'use strict';
        this.$dropdown.on('change', $.proxy(this._handleQuantitySelect, this));
    }

    _handleQuantitySelect() {
        'use strict';
        this.$dropdown.attr('disabled', 'disabled');
        this._redirect(this._getUrl());
    }
    _redirect(url) {
        'use strict';
        window.location = url;
    }
    _getUrl() {
        'use strict';
        return TYROOLA.globals.urlPrefix
            + '/cart/update/'
            + '?id=' + this.$dropdown.attr('name')
            + '&qty=' + this.$dropdown.val()
            + `&${getCsrfTokenKeyParamName()}=${getCsrfTokenKey()}`
            + `&${getCsrfTokenValueParamName()}=${getCsrfTokenValue()}`
        ;
    }
}

export default ItemDropdown;
